import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type ProfileStatsGridProps = {
  learningHours: number;
  masteredKnowledgeCount: number;
  streakDays: number;
};

export function ProfileStatsGrid({
  learningHours,
  masteredKnowledgeCount,
  streakDays,
}: ProfileStatsGridProps) {
  return (
    <View style={styles.grid}>
      <StatCard value={`${learningHours}h`} label="累计学习" />
      <StatCard value={`${masteredKnowledgeCount}`} label="掌握知识" />
      <StatCard value={`${streakDays}天`} label="连续学习" />
    </View>
  );
}

function StatCard({ value, label }: { value: string; label: string }) {
  return (
    <AppCard style={styles.card}>
      <AppText variant="subtitle" weight="bold" align="center">
        {value}
      </AppText>
      <AppText variant="caption" tone="muted" align="center">
        {label}
      </AppText>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    gap: tokens.spacing.sm,
  },
  card: {
    flex: 1,
    minHeight: 88,
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacing.xs,
    paddingHorizontal: tokens.spacing.sm,
  },
});
